// in src/students.js
import React, { useEffect,useState, useCallback, Component } from 'react';
import { DateInput, FormDataConsumer, TopToolbar, ArrayInput, SimpleFormIterator, ArrayField, SingleFieldList, ChipField, List, Edit, Create, Datagrid, TextField, EditButton, LongTextInput, ReferenceInput, SelectInput, SimpleForm, TextInput, required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, SelectField, AutocompleteInput } from 'react-admin';
import { RadioButtonGroupInput, useNotify, useRefresh, useRedirect, Filter, ListButton, CreateButton, ShowButton, DeleteButton, BulkDeleteButton } from 'react-admin';
import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import {createEnrollmentDateValidator} from './utils.js';
import { formatPhoneNumber } from './formatters';



const validateName = [required(), minLength(2), maxLength(45)];
const validateEmail = [required(), email()];
const validatePIN = [required(), regex(/[0-9][0-9][0-9][0-9]/, "Must be 4 digit number")];
const validatePrg = [required()];
// const validateDate = [required(), regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateDate = [regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateDateOpt = [regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateClass = [required()];
const validateSex = [required()];
const validateEStatus = [required()];
// Accept XXX-XXX-XXXX format (backend compatible)
const validatePhone = [required(), regex(/^\d{3}-\d{3}-\d{4}$/, "Valid Phone number is required")];


var d = new Date();
var dt = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
    + ('0' + d.getDate()).slice(-2);


export const TourCreate = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    // Get schoolID from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const schoolID = urlParams.get('schoolID') || '';

    // const onSuccess = () => {
    //     notify(`Your tour request has been submitted`);
    //     redirect('http://lamsaz.com');
    //     refresh();
    // };

    const onSuccess = useCallback(
        (newRecord) => {
            // Show a success message
            notify('Record created successfully', 'success');

            // Redirect to another page (e.g., the list view)
            redirect('/tours/Complete/create');

            // You can also perform additional actions here
        },
        [notify, redirect]
    );

    const dataProvider = useDataProvider();
    const [TourDateTimes, setTourDateTimes] = useState([]);
    const [schoolConfig, setSchoolConfig] = useState(null);
    const [schoolHolidays, setSchoolHolidays] = useState([]);
    const [enrollmentDateValidator, setEnrollmentDateValidator] = useState(null);
    
    // Transform function to add SchoolID to the submission
    const transform = (data) => ({
        ...data,
        SchoolID: schoolID
    });

    // Fetch school configuration and holidays
    useEffect(() => {
        const fetchSchoolConfig = async () => {
            if (!schoolID) {
                return;
            }

            try {
                const apiBaseURL = process.env.REACT_APP_GO_CONNECT_URL || '';
                // Use dedicated public endpoint for tour creation (no authentication required)
                const url = `${apiBaseURL}/api/schools/${encodeURIComponent(schoolID)}/0auth-info`;
                
                // Public endpoint - no authentication required
                const headers = {
                    "Content-Type": "application/json",
                };

                const response = await fetch(url, {
                    method: 'GET',
                    headers: headers,
                    mode: 'cors'
                });

                if (response.ok) {
                    const data = await response.json();
                    // Response contains programs and holidays
                    setSchoolConfig(data);
                    
                    // Extract holidays from school config
                    const holidays = data.holidays || [];
                    setSchoolHolidays(holidays);
                    
                    // Create enrollment date validator with school-specific holidays
                    const validator = createEnrollmentDateValidator(schoolID, holidays);
                    setEnrollmentDateValidator(() => validator);
                } else {
                    console.warn(`Failed to fetch school config for ${schoolID}:`, response.status);
                    // Fallback: create validator with empty holidays
                    setSchoolHolidays([]);
                    setEnrollmentDateValidator(() => createEnrollmentDateValidator(null, []));
                }
            } catch (error) {
                console.error('Error fetching school config:', error);
                // Fallback: create validator with empty holidays
                setSchoolHolidays([]);
                setEnrollmentDateValidator(() => createEnrollmentDateValidator(null, []));
            }
        };

        fetchSchoolConfig();
    }, [schoolID]);

    // Fetch available tour dates and times
    useEffect(() => {
        const fetchTourDateTimes = async () => {
            if (!schoolID) {
                return;
            }

            try {
                // Add schoolID to the URL if available
                let fetchURL = process.env.REACT_APP_TOURDATES_URL;
                if (schoolID) {
                    const separator = fetchURL.includes('?') ? '&' : '?';
                    fetchURL = `${fetchURL}${separator}SchoolID=${encodeURIComponent(schoolID)}`;
                }
                
                const token = localStorage.getItem('token');
                const hdrs = new Headers({
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                });
                
                fetch(fetchURL, { method: 'GET', headers: hdrs })
                    .then(response => {
                        if (response.ok) {
                            response.json().then(json => {
                                if (json != "" && Array.isArray(json)) {
                                    var dates = json.map((date, index) => {
                                        return {
                                            id: date, 
                                            name: date
                                        };
                                    });
                                    console.log('Available tour dates:', dates);
                                    setTourDateTimes(dates);
                                } else {
                                    console.warn('No tour dates available');
                                    setTourDateTimes([]);
                                }
                            });
                        } else {
                            console.error('Failed to fetch tour dates:', response.status);
                            setTourDateTimes([]);
                        }
                    })
                    .catch((e) => {
                        console.error('Error fetching tour dates:', e);
                        setTourDateTimes([]);
                    });
  
            } catch (error) {
                console.error('Error fetching TourDateTimes:', error);
                setTourDateTimes([]);
            }
        };

        fetchTourDateTimes();
    }, [schoolID]);

    return (
        <Create onSuccess={onSuccess} transform={transform} {...props} >
            <SimpleForm>
                <Box p="1em">
                    <Box display="flex">
                        <Box >
                            <Typography variant="h6" gutterBottom>Tour Details</Typography>
                            <Box>
                                <Box display="flex">
                                    <TextInput label="Parent Name" source="ParentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <TextInput label="Student Name" source="StudentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <SelectInput 
                                        style={{ width: "250px" }} 
                                        alwaysOn 
                                        label="Program Applying For" 
                                        source="Program" 
                                        allowEmpty={false} 
                                        choices={
                                            schoolConfig && schoolConfig.programs && schoolConfig.programs.length > 0
                                                ? schoolConfig.programs.map(program => ({
                                                    id: program.name,
                                                    name: `${program.name} (${program.displayName})`
                                                }))
                                                : [
                                                    { id: 'Toddler', name: 'Toddler (18 - 36 months)' },
                                                    { id: 'Primary', name: 'Primary (3 - 6 years)' },
                                                ]
                                        } 
                                        validate={required()} 
                                    />
                                </Box>
                                <Box>
                                    <DateInput 
                                        style={{ width: "200px" }} 
                                        label="Enrollment Date" 
                                        source="EnrollmentDate" 
                                        validate={enrollmentDateValidator ? [required(), enrollmentDateValidator] : [required(), (value) => createEnrollmentDateValidator(null, [])(value)]} 
                                    />
                                </Box>
                                <Box>
                                    <TextInput label="Email" source="Email" validate={validateEmail}/>
                                </Box>
                                <Box>
                                    <TextInput 
                                        label="Phone" 
                                        source="Phone" 
                                        validate={validatePhone}
                                        format={formatPhoneNumber}
                                        parse={formatPhoneNumber}
                                        placeholder="555-123-4567"
                                    />
                                </Box>
                                <Box>
                                    <SelectInput style={{ width: "250px" }} label="Available Dates & Time" source="DateTime" choices={TourDateTimes} optionText="name" optionValue="id" validate={required()}/>
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </SimpleForm>
        </Create >
    );
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


